
















import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'ConfrimDialog',
  props: {
    message: {
      type: String,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    cancelAction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      modal: false,
    };
  },
  created() {
    this.$mount();
    document.body.appendChild(this.$el);
    this.modal = true;
  },
  methods: {
    onOk() {
      this.okAction();
      this.close();
    },
    onCancle() {
      this.cancelAction();
      this.close();
    },
    close() {
      this.modal = false;
      setTimeout(() => {
        if (document.body.contains(this.$el)) {
          document.body.removeChild(this.$el);
        }
        this.$destroy();
      }, 200);
    },
  },
});

